import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionalAccessPolicy } from '@microsoft/microsoft-graph-types-beta';

@Component({
    selector: 'cap-target-resources-control',
    templateUrl: './cap-target-resources-control.component.html',
    styleUrls: ['./cap-target-resources-control.component.scss', '../../../../../styles/baseline-style.scss'],
})
export class CapTargetResourcesControlComponent implements OnInit {
    @Input() policy: ConditionalAccessPolicy;
    @Input() readOnly: boolean;
    @Input() form: FormGroup;
    @Input() errorsString: string = '';

    includeApplicationRadioGroup: 'All' | 'None';

    constructor() {}

    ngOnInit(): void {
        this.includeApplicationRadioGroup = this.includeApplicationsController?.value?.[0];
    }

    toggleIncludeApplications() {
        this.includeApplicationsController.setValue([this.includeApplicationRadioGroup]);
        //accept array
    }

    get includeApplicationsController(): FormControl {
        return this.conditionsController?.get('applications')?.get('includeApplications') as FormControl;
    }

    get conditionsController(): FormGroup {
        return this.form.get('conditions') as FormGroup;
    }
}
